import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('orca.credentials') || '',
    email:  localStorage.getItem('orca.email') || '',
    firstName: localStorage.getItem('orca.firstName') || '',
    lastName: localStorage.getItem('orca.lastName') || '',
    roles: localStorage.getItem('orca.roles') || [],
    branches: localStorage.getItem('orca.branches') || [],
    expirationDate: localStorage.getItem('orca.expirationDateTemplate') || '',
    rolesEnum: {
      MEMBER: "MEMBER",
      STAFF: "STAFF",
      REPRESENTATIVE: "REPRESENTATIVE",
      SUPPORT: "SUPPORT",
      TREASURER: "TREASURER",
      ADMIN: "ADMIN"
    }
  },
  strict: debug,
  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, payload) {
      state.status = 'success'
      state.token = payload.token
      state.email = payload.email
      state.roles = payload.roles
      state.branches = payload.branches
      state.firstName = payload.firstName
      state.lastName = payload.lastName
      state.expirationDate = payload.expirationDate
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
      state.token = ''
    }
  },
  actions: {
    login({commit}, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({url: 'auth', data: user, method: 'POST'})
          .then(resp => {
            const token = resp.data.token
            const email = resp.data.email
            const firstName = resp.data.firstName
            const lastName = resp.data.lastName
            const expirationDate = resp.data.validUntil
            const roles = resp.data.roles
            const branches = resp.data.branches
            localStorage.setItem('orca.email', email)
            localStorage.setItem('orca.firstName', firstName)
            localStorage.setItem('orca.lastName', lastName)
            localStorage.setItem('orca.roles', roles)
            localStorage.setItem('orca.branches', branches)
            localStorage.setItem('orca.expirationDateTemplate', expirationDate)
            localStorage.setItem('orca.credentials', token)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            commit('auth_success', {'token': token, 'email': email, 'firstName': firstName, 'lastName': lastName, 'expirationDate': expirationDate, 'roles': roles, 'branches': branches})
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('orca.credentials')
            localStorage.removeItem('orca.email')
            localStorage.removeItem('orca.firstName')
            localStorage.removeItem('orca.lastName')
            localStorage.removeItem('orca.roles')
            localStorage.removeItem('orca.branches')
            localStorage.removeItem('orca.expirationDateTemplate')
            reject(err)
          })
      })
    },
    logout({commit}) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('orca.credentials')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    expirationDate: state => state.expirationDate,
    getFirstName: state => state.firstName,
    getLastName: state => state.lastName,
    getEmail: state => state.email,
    isStaff: state => state.roles && state.roles.indexOf(state.rolesEnum.MEMBER) >= 0,
    isAdmin: state => state.roles && state.roles.indexOf(state.rolesEnum.ADMIN) >= 0,
    isRepresentative: state => state.roles && state.roles.indexOf(state.rolesEnum.REPRESENTATIVE) >= 0,
    isTreasurer: state => state.roles && state.roles.indexOf(state.rolesEnum.TREASURER) >= 0,
    getBranches: state => state.branches,
    hasDashBoardAccess: state => state.roles && (state.roles.indexOf(state.rolesEnum.ADMIN) >= 0 || state.roles.indexOf(state.rolesEnum.TREASURER) >= 0 || state.roles.indexOf(state.rolesEnum.REPRESENTATIVE) >= 0)
  }
})



// WEBPACK FOOTER //
// ./src/config/store.js